export default {
  opponentRank: {
    rankSummary: "Ranked {{rank}} in {{marketName}}",
    feedSubtitle: "{{team}} DEF Rank",
  },
};